import { Carousel } from 'antd';

import Section from 'layouts/Section/Section';

import { useMobileDesign } from 'hooks/useMobileDesign';

import { CAROUSEL_AUTOPLAY_SPEED_MS } from 'constants/commons';

import { ReactComponent as ArrowLeft } from 'assets/icons/arrowLeftClean.svg';
import { ReactComponent as ArrowRight } from 'assets/icons/arrowRightClean.svg';

import styles from './OurCLients.module.scss';
import items from './items';

const HIDE_CONTROLS_BREAKPOINT = 768;

const OurCLients = () => {
  const isHideControlsBreakpoint = useMobileDesign(HIDE_CONTROLS_BREAKPOINT);

  return (
    <Section>
      <Carousel
        responsive={[
          { breakpoint: 1200, settings: { slidesToShow: 4 } },
          { breakpoint: 810, settings: { slidesToShow: 3 } },
          { breakpoint: 560, settings: { slidesToShow: 2 } },
          { breakpoint: 440, settings: { slidesToShow: 1 } }
        ]}
        slidesToShow={6}
        className="clients-carousel"
        arrows
        nextArrow={isHideControlsBreakpoint ? <></> : <ArrowRight />}
        prevArrow={isHideControlsBreakpoint ? <></> : <ArrowLeft />}
        autoplaySpeed={CAROUSEL_AUTOPLAY_SPEED_MS}
        autoplay
        infinite
        dots={!isHideControlsBreakpoint}
      >
        {items.map((url) => (
          <div className={styles.imageContainer} key={url}>
            <img
              className={styles.image}
              src={url}
              alt="client logo"
              loading="lazy"
            />
          </div>
        ))}
      </Carousel>
    </Section>
  );
};

export default OurCLients;
